import orderBy from 'lodash/orderBy'
import capitalize from 'lodash/capitalize'
import last from 'lodash/last'
import floor from 'lodash/floor'
import Moment from 'moment'
import { DateTime } from 'luxon'

export const agrupamentoMensal = (array, propertyName, secondPropertyName, isPercent = false) => {
  const newArray = []
  assertArray(array).forEach((object) => {
    if (object['NUM_ANO'] > 0) {
      const dateFull = DateTime.fromObject({ year: object['NUM_ANO'], month: object['NUM_MES'], locale: 'pt-BR' })
      const ano = object['NUM_ANO']
      const mes = object['NUM_MES']
      const anoMesNome = capitalize(dateFull.toFormat('MMMM/yy'))
      const anoMes = dateFull.toFormat('yyyy-MM')
      const valor = calcularValor(object, propertyName, secondPropertyName, isPercent)
      newArray.push({ data: anoMesNome, ano, mes, valor, anoMes, dataMoment: dateFull, tipo: 'mensal' })
    }
  })
  return orderBy(newArray, 'anoMes', 'asc')
}

const parseMonetFormat = (object) => {
  const { NUM_ANO, NUM_SEMANA } = object

  const startOfYear = DateTime.fromObject({ year: NUM_ANO }).startOf('year')

  // Find the Monday of the week that contains the first day of the year
  const firstWeekStart = startOfYear.minus({ days: startOfYear.weekday - 1 })

  // advance weeks from this Monday
  const dataInicial = firstWeekStart.plus({ weeks: NUM_SEMANA - 1 })
  let dataFinal = dataInicial.plus({ days: 6 })

  // If it goes past the end of the year, limit the End date
  const endOfYear = DateTime.fromObject({ year: NUM_ANO }).endOf('year')
  if (dataFinal > endOfYear) dataFinal = endOfYear

  return [dataInicial, dataFinal]
}

const parseIsoFormat = (object) => {
  // Expects NUM_SEMANA to be IYYYIW - iso year + iso week
  const isoYear = Math.floor(object['NUM_SEMANA'] / 100)
  const isoWeek = object['NUM_SEMANA'] % 100

  const dataInicial = Moment().isoWeekYear(isoYear).isoWeek(isoWeek).isoWeekday(1)

  const dataFinal = Moment().isoWeekYear(isoYear).isoWeek(isoWeek).isoWeekday(7)

  return [dataInicial, dataFinal]
}

export const agrupamentoSemanal = (array, propertyName, secondPropertyName, isPercent = false) => {
  const newArray = []
  assertArray(array).forEach((object) => {
    if (object['NUM_ANO'] > 0) {
      let parser = null
      let formatter = null
      if (object['NUM_SEMANA'] > 1000) {
        // Concatenated format
        parser = parseIsoFormat
        formatter = (date) => date.format('DD/MM/YYYY')
      } else {
        // Unconcatenated
        parser = parseMonetFormat
        formatter = (date) => date.toFormat('dd/MM/yyyy')
      }
      let [dataInicial, dataFinal] = parser(object)
      const data = [formatter(dataInicial), formatter(dataFinal)]
      const anoSemana = dataInicial
      const valor = calcularValor(object, propertyName, secondPropertyName, isPercent)
      newArray.push({ data, valor, anoSemana, dataInicial, tipo: 'semanal', object })
    }
  })
  return orderBy(newArray, 'anoSemana', 'asc')
}

export const agrupamentoDiario = (array, propertyName) => {
  const newArray = []
  assertArray(array).forEach((object) => {
    if (object['NUM_ANOMESDIA'] > 0) {
      const data = DateTime.fromFormat(object['NUM_ANOMESDIA'].toString(), 'yyyyMMdd').toLocaleString()
      const dataOrdernavel = object['NUM_ANOMESDIA']
      const valor = object[propertyName]
      newArray.push({ data, valor, dataOrdernavel })
    }
  })
  return orderBy(newArray, 'dataOrdernavel', 'asc')
}

const calcularValor = (object, propertyName, secondPropertyName, isPercent) => {
  if (secondPropertyName) {
    if (isPercent) return (object[propertyName] / (object[propertyName] + object[secondPropertyName])) * 100
    return object[propertyName] / object[secondPropertyName]
  }
  return object[propertyName]
}

export const calculateTotal = (array, propertyNames, descriptivePropertyName) => {
  if (!Array.isArray(array)) throw new Error('The first parameter has to be an array')
  if (!propertyNames) throw new Error('propertyNames is required')
  if (descriptivePropertyName) {
    array.push({
      [descriptivePropertyName]: 'Total:',
    })
  } else array.push({})
  for (let property of propertyNames) {
    let total = 0
    for (let element of array) {
      if (element[property]) total += element[property]
    }
    array.splice(-1, 1, {
      [property]: total,
      ...last(array),
    })
  }
  return array
}

export const assertArray = (data) => {
  if (Array.isArray(data)) return data
  else if (data) return [data]
  else return []
}

export const porcentagemProduto = (vendas, total) => {
  return floor((vendas / total) * 100, 2)
}

export const localeString = (value, digits, language = 'pt-BR') => {
  // if (value === 0) return '-'
  if (!value && value !== 0) return value
  if (digits === 0) return Math.trunc(value).toLocaleString(language)
  if (!digits) return value.toLocaleString(language)
  return value.toLocaleString(language, { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export const abbreviation = (value, { isCurrency, isInteger } = {}) => {
  if (value < 1000) {
    if (isInteger) return localeString(value)
    return localeString(value, isCurrency ? 2 : 1)
  }
  if (value < 1000000) return localeString(value / 1000, 1) + ' k'
  if (value < 1000000000) return localeString(value / 1000000, 1) + ' mi'
  if (value < 1000000000000) return localeString(value / 1000000000, 1) + ' bi'
  else return localeString(value / 1000000000000, 1) + ' tri'
}

export const sortKeepTotal = (items, index, isDescending) => {
  if (index) {
    const total = items.pop()
    const orderedArray = orderBy(items, index, isDescending ? 'desc' : 'asc')
    orderedArray.push(total)
    return orderedArray
  }
  return items
}

export const arrayMove = (array, fromIndex, toIndex) => {
  if (!array.length) return []
  let element = array[fromIndex]
  array.splice(fromIndex, 1)
  array.splice(toIndex, 0, element)
  return array
}

export const createCsvFromArray = (array, csvName, headers = []) => {
  let localArray = []

  array.forEach((object) => {
    localArray.push(Object.values(object).join(';'))
  })
  let csvContent = 'data:text/csv;charset=utf-8,'

  if (headers.length) {
    csvContent += headers.join(';') + '\r\n'
  }

  localArray.forEach((rowArray) => {
    csvContent += rowArray + '\r\n'
  })

  let encodedUri = encodeURI(csvContent.replace(/#/g, ' '))
  let link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${csvName}.csv`)
  // link.innerHTML = 'Click Here to download'
  document.body.appendChild(link)
  link.click()
}

export const getCsvFromBucket = (url, csvName) => {
  var link = document.createElement('a')
  link.href = url
  link.download = csvName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const createJSONFromObject = (obj, fileName) => {
  let jsonContent = 'data:text/json;charset=utf-8,'

  jsonContent += JSON.stringify(obj, null, 4)
  let encodedUri = encodeURI(jsonContent.replace(/#/g, ' '))
  let link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${fileName}.csv`)
  // link.innerHTML = 'Click Here to download'
  document.body.appendChild(link)
  link.click()
}

export const convertByteToMegabyte = (bytes) => {
  const megabyte = bytes / 1000000
  return megabyte
}

export const formatFloatToKg = (weight) => {
  if (weight < 0.01) return '-'
  if (weight >= 1) return localeString(weight).concat('Kg')
  return weight
    .toFixed(3)
    .slice(weight < 0.1 ? 3 : 2)
    .concat('g')
}

export const floatToPercentString = (value) => {
  if (value === 0) return '0%'
  return `${Math.floor(value * 100)}%`
}

export const formatProductType = (value) => {
  if (!value) return ''
  if (value === 'personalized') return 'Personalizada'
  if (value === 'club') return 'Clube'
  return 'Geral'
}

export const inputOnlyRegex = (regex, evt) => {
  let char = String.fromCharCode(evt.keyCode) // Get the character
  if (regex.test(char)) return true
  else evt.preventDefault() // If not match, don't add to input text
}

export const dateToMinutesAgo = (date) => {
  const dateNow = DateTime.now()
  const dateFormatted = DateTime.fromISO(date).setZone('UTC')
  const diffMin = Math.round(dateNow.diff(dateFormatted, ['minutes']).minutes)
  if (diffMin < 1) return 'Agora'
  if (diffMin < 2) return 'Há 1 min'
  if (diffMin < 60) return `Há ${diffMin} min`
  if (diffMin < 120) return 'Há 1 hora'
  const diffHour = Math.round(dateNow.diff(dateFormatted, ['hours']).hours)
  if (diffHour < 24) return `Há ${diffHour} horas`
  if (diffHour < 48) return 'Há 1 dia'
  const diffDay = Math.round(dateNow.diff(dateFormatted, ['days']).days)
  if (diffDay < 30) return `Há ${diffDay} dias`
  if (diffDay < 60) return 'Há 1 mês'
  const diffMonth = Math.round(dateNow.diff(dateFormatted, ['months']).months)
  if (diffMonth < 12) return `Há ${diffMonth} meses`
  if (diffMonth < 24) return 'Há 1 ano'
  const diffYear = Math.round(dateNow.diff(dateFormatted, ['years']).years)
  return `Há ${diffYear} anos`
}

export const putEllipsis = (str, finalPoint) => {
  return str && str.length > finalPoint ? str.substring(0, finalPoint) + '...' : str
}

export const getStatusLabel = (status) => {
  switch (status?.toUpperCase()) {
    case 'INACTIVE':
      return {
        color: '#6B7580',
        text: 'Inativa',
      }
    case 'DRAFT':
      return {
        color: '#6B7580',
        text: 'Rascunho',
      }
    case 'SCHEDULED':
      return {
        color: '#EDB900',
        text: 'Agendada',
      }
    case 'FINISHED':
      return {
        color: '#0079F2',
        text: 'Concluída',
      }
    case 'ACTIVE':
      return {
        color: '#0DA740',
        text: 'Ativa',
      }
    case 'INDUSTRY_PROPOSAL':
      return {
        color: '#002040',
        text: 'Proposta Indústria',
      }
    case 'PAUSED':
      return {
        color: '#F15435',
        text: 'Suspensa',
      }
    case 'INDUSTRY_REJECTED':
      return {
        color: '#B3280D',
        text: 'Rejeitada',
      }
    case 'EXPIRED':
      return {
        color: '#F15435',
        text: 'Expirada',
      }
    case 'PROCESSING':
      return {
        color: '',
        text: 'Processando',
      }
    default:
      return {
        color: '#898989',
        text: 'Rascunho',
      }
  }
}

export const getPeriod = (initialDate, finalDate) => {
  return initialDate && finalDate
    ? `${DateTime.fromISO(initialDate).setZone('UTC').toFormat('dd/MM/yyyy')} - ${DateTime.fromISO(finalDate).setZone('UTC').toFormat('dd/MM/yyyy')}`
    : '-'
}

export const getUnits = (item, useNameInUniqueUnit) => {
  if (!item.units || !item.units.length) return '-'

  const filteredUnits = item.units.filter((unit) => unit.name)

  if (filteredUnits.length >= 2) {
    return `${filteredUnits.length} lojas`
  } else {
    return useNameInUniqueUnit ? filteredUnits[0].name : `${filteredUnits.length} loja`
  }
}

export const getWhatsappRegisters = (item, useNameInUniqueUnit) => {
  if (!item.registers || !item.registers.length) return '-'

  if (item.registers.length >= 2) {
    return `${item.registers.length} whatsapps`
  } else {
    return useNameInUniqueUnit ? item.registers[0].name : `${item.registers.length} whatsapp`
  }
}

export const putEmptyValue = (value, emptyValue) => {
  if (isNaN(value)) return emptyValue
  return value || emptyValue
}

export const parseLocaleFloat = (str) => {
  if (str) {
    str = str.replace(/\s/g, '')
    if (str.indexOf(',') > -1 && str.indexOf('.') > -1) {
      if (str.indexOf(',') < str.indexOf('.')) {
        str = str.replace(/,/g, '').replace('.', '.')
      } else {
        str = str.replace(/\./g, '').replace(',', '.')
      }
    } else if (str.indexOf(',') > -1) {
      str = str.replace(',', '.')
    }
    return parseFloat(str)
  } else return 0
}

export const roundFloat = (value, fractionDigits = 2) => {
  const multiplier = Math.pow(10, fractionDigits)
  return Math.round(value * multiplier) / multiplier
}
